import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet'
import { CategoryDetailContext, type CategoryDetailContextValue } from './context'

type Props = CategoryDetailContextValue & {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
}

export function CategoryDetailSheet({
  open,
  onOpenChange,
  children,
  ...ctx
}: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="rounded-t-2xl max-h-[85vh]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <SheetHeader>
          <SheetTitle>
            <span className="flex items-center gap-2">
              <span
                className="h-3 w-3 shrink-0 rounded-sm"
                style={{ backgroundColor: ctx.categoryColor }}
              />
              {ctx.categoryName}
            </span>
          </SheetTitle>
          <SheetDescription className="sr-only">
            {ctx.categoryName}の詳細内訳
          </SheetDescription>
        </SheetHeader>
        <CategoryDetailContext.Provider value={ctx}>
          <div
            className="min-h-0 flex-1 space-y-4 px-4 pb-8 overflow-y-auto"
            data-no-drag
          >
            {children}
          </div>
        </CategoryDetailContext.Provider>
      </SheetContent>
    </Sheet>
  )
}
